import request from '@/utils/request'


// 查询排列三列表
export function listPl3(query) {
    return request({
        url: '/admin/lottery/pl3/list',
        method: 'get',
        params: query
    })
}

// 查询最新一期排列三数据
export function latestPl3() {
    return request({
        url: '/admin/lottery/pl3/latest',
        method: 'get',
    })
}

// 初始化排列三数据
export function initAllPl3() {
    return request({
        url: '/admin/lottery/pl3/initAll',
        method: 'post'
    })
}

// 补全排列三历史数据
export function fillHistoryData() {
    return request({
        url: '/admin/lottery/pl3/fillHistoryData',
        method: 'post'
    })
}

// 初始化排列三统计数据
export function initAllPl3C() {
    return request({
        url: '/admin/lottery/pl3/initAllC',
        method: 'post'
    })
}

// 刷新排列三缓存
export function refreshPl3Cache() {
    return request({
        url: '/admin/lottery/pl3/refreshCache',
        method: 'delete',
    })
}
// 生成排列三
export function generatePl3(data) {
    return request({
        url: '/admin/lottery/pl3/generate',
        method: 'post',
        data:data
    })
}

// 查询排列三中奖数据
export function getPl3WinningData(query){
    return request({
        url: '/admin/lottery/pl3/getWinningData',
        method: 'get',
        params: query
    })
}
// 查询排列三历史同期中奖数据
export function getNextPl3History(period){
    return request({
        url: '/admin/lottery/pl3/getNextHistory?period='+period,
        method: 'get'
    })
}

// 查询排列三下期数字频率
export function getNextNumFrequency(query){
    return request({
        url: '/admin/lottery/pl3/getNextNumFrequency',
        method: 'get',
        params: query
    })
}
